import Services from './base-services'

const service = new Services('challengeaudio')

export default {
  getVoices(testId: number) {
    return service.contentGet(`voices/${testId}`)
  },
  generateQuestionAudio(text: string) {
    return service.contentPost('generate_audio', { text })
  },
}
